import { APIPath } from '../constants';
import { CommonUtility } from '../common';
import { BaseService } from './base';
import type {
  GenerateManifestReportPayload,
  GenerateManifestReportResponse,
  ManifestCarriersParams,
  ManifestCarriersResponse,
} from '../../types/manifest';

class Manifest {
  getCarriers = (params: ManifestCarriersParams): Promise<ManifestCarriersResponse> => {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.manifestCarriers}?${query}`);
  };

  generateReport = (
    payload: GenerateManifestReportPayload,
  ): Promise<GenerateManifestReportResponse> => {
    return BaseService.post(APIPath.manifestReport, payload);
  };
}

const ManifestService = new Manifest();
Object.freeze(ManifestService);
export { ManifestService };
